import { IMucTriNang } from "../../../model/respone/category/IMucTriNang";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eMucTriNangActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IMucTriNang[],
  LOAD_ERRR: "",

  SAVE_START: {} as IMucTriNang,
  SAVE_SUCCESS: {} as IMucTriNang,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  SHOW_EDIT_MODAL: {} as undefined | IMucTriNang,
  CLOSE_EDIT_MODAL: undefined,
};
export const eMucTriNangActionIds = generateActionTypeIds(
  eMucTriNangActionsObj,
  "MUC_TRI_NANG"
);
export type IMucTriNangActionTypes = IGenericActionType<
  typeof eMucTriNangActionsObj,
  "MUC_TRI_NANG"
>;
